import React from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";

// external-global styles must be imported in your JS.
import styles from "./index.scss";

class LayoutComponent extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  render() {
    return <div className="wrapper">{this.props.children}</div>;
  }
}

export default withStyles(styles)(LayoutComponent);



// WEBPACK FOOTER //
// ./src/components/LayoutComponent/index.js